import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "../StatusCard";
import { MetricCard } from "../MetricCard";
import { HealthBadge } from "../HealthBadge";
import { QueryStateBoundary } from "../QueryStateBoundary";
import { useSyncStatus } from "@/hooks/queries/useSyncStatus";

interface SyncStatusPayload {
  has_run: boolean;
  summary: {
    results: Array<{ resource: string; is_success: boolean }>;
    broker_snapshot_available: boolean;
  } | null;
}

export function SynchronizationSection(): React.JSX.Element {
  const syncQuery = useSyncStatus();

  return (
    <StatusCard title="Synchronization">
      <QueryStateBoundary query={syncQuery}>
        {(payload) => {
          const sync = payload as unknown as SyncStatusPayload;
          const status = !sync.has_run
            ? "not_run"
            : sync.summary?.results.every((r) => r.is_success)
              ? "ok"
              : "degraded";
          return (
            <Stack spacing={1.5}>
              <MetricCard label="Synchronization Status" render={<HealthBadge status={status} />} />
              <MetricCard
                label="Last Synchronization"
                value={sync.has_run ? "Completed at least once this session" : null}
              />
              {/* Backend's SyncStatusDto has no concept of a queued/pending operation
                  count today — reporting that honestly rather than fabricating one. */}
              <MetricCard label="Pending Operations" value={null} />
            </Stack>
          );
        }}
      </QueryStateBoundary>
    </StatusCard>
  );
}
